import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import { REGULAR_PATH } from '../../env';
import {
  Segment,
  Table,
  Button,
  ButtonGroup,
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import * as ExcelJS from 'exceljs/dist/exceljs.js';

const accessToken = () => window.localStorage.getItem('user');

const ELIGIBLE_ORGS = [
  '6020bcbf1d41c84da5bcb6a3',
  '6992a801646454e3da6bd819',
];

export default class Analytics extends Component {
  state = {
    liveToday: '',
    moving: '',
    stopped: '',
    needToCheck: '',
    updatedOn: '',
    tableData: [],
    tableTitle: '',
    loading: false,
    total: 0,
  };

  componentDidMount() {
    if (
      ELIGIBLE_ORGS.includes(window.localStorage.getItem('organization'))
    ) {
      this.getAssetList();
    }
  }

  getAssetList = () => {
    this.setState({ loading: true });

    axios({
      method: 'GET',
      url: `${REGULAR_PATH}/assets/list?access_token=${accessToken()}`,
    })
      .then(({ data }) => {
        const assets = data.map((item) => item._id.$oid);
        axios
          .post(
            `${REGULAR_PATH}/assets/dashboard_web?access_token=${accessToken()}`,
            JSON.stringify({ assets }),
          )
          .then(({ data }) => {
            this.setState({
              liveToday: data.live_today,
              moving: data.moving,
              stopped: data.stopped,
              needToCheck: data.need_to_check,
              updatedOn: data.updated_on,
              tableData: data.live_today.assets,
              tableTitle: 'Live Today',
              total: data.moving.assets.length + data.stopped.assets.length,
            });
            this.setState({ loading: false });
          })
          .catch((error) => {
            console.error(error);
            this.setState({ loading: false });
          });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ loading: false });
      });
  };

  handleTableData = (data) => {
    const { liveToday, moving, stopped, needToCheck } = this.state;
    switch (data) {
      case 'liveToday':
        this.setState({ tableData: liveToday.assets });
        this.setState({ tableTitle: 'Live Today' });
        break;
      case 'moving':
        this.setState({ tableData: moving.assets });
        this.setState({ tableTitle: 'Moving' });
        break;
      case 'stopped':
        this.setState({
          tableData: stopped.assets.map((data) => ({ ...data, speed: 0 })),
        });
        this.setState({ tableTitle: 'Stopped' });
        break;
      case 'needToCheck':
        this.setState({
          tableData: needToCheck.assets.map((data) => ({ ...data, speed: 0 })),
        });
        this.setState({ tableTitle: 'Need To Check' });
        break;
      default:
        this.setState({ tableData: [] });
        this.setState({ tableTitle: '' });
    }
  };

  downloadExcel = () => {
    const { tableData, tableTitle } = this.state;
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Finder GPS Tracking';
    workbook.created = new Date();

    workbook.addWorksheet('Dashboard Report');

    const worksheet = workbook.getWorksheet('Dashboard Report');

    worksheet.addRow(['Finder GPS Tracking']);
    worksheet.addRow();
    worksheet.addRow([`${tableTitle} : ${tableData.length}`]);
    worksheet.addRow([
      `Generated on ${moment().format('MMMM Do, YYYY, hh:mm:ss A')}`,
    ]);
    worksheet.addRow([`Generated By: ${window.localStorage.getItem('email')}`]);

    worksheet.addRow();

    worksheet.addRow();

    worksheet.columns = [
      { width: 10 },
      { width: 25 },
      { width: 25 },
      { width: 10 },
      { width: 40 },
      { width: 50 },
    ];

    worksheet.addRow([
      'No',
      'Asset Name',
      'Time',
      'Speed',
      'Nearest Landmark',
      'Coordinates',
    ]);

    tableData.forEach(({ name, speed, nearest_landmark, time, loc }, index) =>
      worksheet.addRow([
        index + 1,
        name,
        time ? moment(time).utc(true).local().format('DD/MM/YY, H:mm A') : '-',
        speed,
        nearest_landmark,
        `${loc.coordinates[1]},${loc.coordinates[0]}`,
      ]),
    );

    // Align the first column (No) to the left
    worksheet.eachRow((row, rowNumber) => {
      const cell = row.getCell(1);
      cell.alignment = { vertical: 'middle', horizontal: 'left' };
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/octet-binary',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Dashboard_${moment().format(
        'MMMM Do, YYYY, hh:mm:ss A',
      )}.xlsx`;
      a.click();
      a.remove();
    });
  };

  render() {
    const {
      liveToday,
      moving,
      stopped,
      needToCheck,
      tableData,
      tableTitle,
      loading,
      total,
    } = this.state;

    if (
      !ELIGIBLE_ORGS.includes(window.localStorage.getItem('organization'))
    ) {
      return <Redirect to='/' />;
    }

    if (loading) {
      return (
        <Dimmer active={true}>
          <Loader indeterminate size='big'>
            Loading...
          </Loader>
        </Dimmer>
      );
    }

    return (
      <Segment>
        <div>
          <div style={{ textAlign: 'center' }}>
            <div>
              <ButtonGroup>
                <Button disabled={true}>
                  <span style={{ fontSize: 20 }}>{total}</span>
                  <div style={{ marginTop: 5 }}>Total Asset </div>
                </Button>

                <Button
                  color='blue'
                  onClick={() => this.handleTableData('liveToday')}
                >
                  <span style={{ fontSize: 20 }}>{liveToday.count}</span>
                  <div style={{ marginTop: 5 }}>Live Today </div>
                </Button>
                <Button
                  color='green'
                  onClick={() => this.handleTableData('moving')}
                >
                  <span style={{ fontSize: 20 }}>{moving.count}</span>
                  <div style={{ marginTop: 5 }}>Moving </div>
                </Button>
                <Button
                  color='red'
                  onClick={() => this.handleTableData('stopped')}
                >
                  <span style={{ fontSize: 20 }}>{stopped.count}</span>
                  <div style={{ marginTop: 5 }}>Stopped </div>
                </Button>
                <Button
                  color='grey'
                  onClick={() => this.handleTableData('needToCheck')}
                >
                  <span style={{ fontSize: 20 }}>{needToCheck.count}</span>
                  <div style={{ marginTop: 5 }}>Need to Check </div>
                </Button>
              </ButtonGroup>
            </div>
          </div>

          {tableData.length > 0 ? (
            <Segment>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h3>{tableTitle}</h3>
                <Button color='teal' onClick={this.downloadExcel}>
                  Download
                </Button>
              </div>

              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>No</Table.HeaderCell>
                    <Table.HeaderCell>Asset Name</Table.HeaderCell>
                    <Table.HeaderCell>Time</Table.HeaderCell>
                    <Table.HeaderCell>Speed (km/h)</Table.HeaderCell>
                    <Table.HeaderCell>Nearest Landmark</Table.HeaderCell>
                    <Table.HeaderCell>Coordinates</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {tableData &&
                    tableData.map(
                      (
                        { asset_id, name, speed, nearest_landmark, time, loc },
                        index,
                      ) => (
                        <Table.Row key={asset_id}>
                          <Table.Cell>{index + 1}</Table.Cell>
                          <Table.Cell>{name}</Table.Cell>
                          <Table.Cell>
                            {time
                              ? moment(time)
                                  .utc(true)
                                  .local()
                                  .format('DD/MM/YY, hh:mm A')
                              : '-'}
                          </Table.Cell>
                          <Table.Cell>{speed}</Table.Cell>
                          <Table.Cell>{nearest_landmark}</Table.Cell>
                          <Table.Cell>{`${loc.coordinates[1]}, ${loc.coordinates[0]}`}</Table.Cell>
                        </Table.Row>
                      ),
                    )}
                </Table.Body>
              </Table>
            </Segment>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: 22, marginTop: 25 }}>No data available</p>
            </div>
          )}
        </div>
      </Segment>
    );
  }
}
